import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SetupPageService } from '@core/services/setup-page/setup-page.service';
import { Retailer } from '@root/app.interfaces';
import { RetailerInfoModalComponent } from '@shared/modals/retailer-info-modal/retailer-info-modal.component';
import { ModalService } from '@core/services/modal/modal.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CONFIG } from '@root/app.config';

@Component({
	selector: 'app-retailer-card',
	templateUrl: './retailer-card.component.html',
	styleUrls: ['./retailer-card.component.scss', './retailer-card.responsive.scss'],
	animations: [
		trigger('slide', [
			state('open', style({ height: '*' })),
			state('closed', style({ height: '0px' })),
			transition('open <=> closed', animate('300ms ease-in-out')),
		]),
	],
})
export class RetailerCardComponent {
	@Input() retailer: Retailer;
	@Input() insideMap: boolean;
	@Input() disableSelection: boolean;
	@Input() hidePremium: boolean;

	@Output() mouseEnterEvent: EventEmitter<{ event: MouseEvent; retailer: Retailer }> = new EventEmitter();
	@Output() clickEvent: EventEmitter<Retailer> = new EventEmitter();
	@Output() headerClickEvent: EventEmitter<Retailer> = new EventEmitter();

	isMobile: boolean = this.setupPageService.mobileAndTabletCheck();

	get premiumStatusText(): string {
		return window.innerWidth > CONFIG.breakpoints.phone
			? 'retailer_action.block_status.premium.short_name'
			: 'retailer_action.block_status.premium.name';
	}

	constructor(
		private setupPageService: SetupPageService,
		private modalService: ModalService,
	) {}

	onMouseEnter(event: MouseEvent): void {
		this.mouseEnterEvent.emit({ event, retailer: this.retailer });
	}

	onClickRetailerEvent() {
		this.clickEvent.emit(this.retailer);
	}

	onHeaderClick(): void {
		this.headerClickEvent.emit(this.retailer);
	}

	onOpenRetailerInfoModal() {
		this.modalService.openResponsiveDialog({
			component: RetailerInfoModalComponent,
			maxWidth: '280px',
			width: '100%',
			panelClass: '',
		});
	}
}
